export default "__VITE_ASSET__DBdaCm49__"